import events from 'events.js';
import ko from 'knockout';
import query from 'query.js';
import SearchManager, {Filter} from 'search/search.js';

const FILTER_TYPES = {
    'total': {
        title: 'All Results',
        icon: 'fa-search',
    },
    'factsheet_categories': {
        title: 'Condition Pages',
        icon: 'fa-stethoscope',
    },
    'drugs': {
        title: 'Product Pages',
        icon: 'fa-drug',
    },
};

class FactsheetSearchManager extends SearchManager {
    constructor() {
        super();
        this.filterTypes = FILTER_TYPES;
        this.baseUrl = '/factsheets/search/';
        this.types = ['factsheet_categories', 'drugs'];
        this.queryFilter = 'factsheets';
        this.isSearchResults(true);

        // Set default filter
        const filterType = this.filterTypes.total;
        this.currentFilter(
            new Filter(filterType.title, 'total', filterType.icon, this),
        );
    }
}

(async function() {
    await events.ready();
    const mgr = new FactsheetSearchManager();
    const filterType = query.parse().filter || '';
    mgr.autoSetQuery = true;
    const q = decodeURIComponent((query.parse().q || '').replace(/\+/g, ' '));
    await mgr.search(q, true);
    mgr.typedQuery(q);
    const filter = mgr.filters().find((f) => f.type === filterType);
    if (filter) {
        mgr.currentFilter(filter);
    }
    mgr.elems.push(document.getElementById('search-area'));
    mgr.elems.push(document.getElementById('search-title'));
    ko.applyBindings(mgr, document.getElementById('search-area'));
    ko.applyBindings(mgr, document.getElementById('search-title'));
    ko.applyBindings(mgr, document.getElementsByClassName('js-query')[0]);
})();
